"use strict";

exports.__esModule = true;
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  Id: {
    displayName: "ID",
    type: "String",
    guarded: true,
    sortable: true,
    filterable: true
  },
  GivenName: {
    displayName: "First name",
    type: "String",
    rules: [],
    value: "",
    sortable: true,
    filterable: true
  },
  FamilyName: {
    displayName: "Last name",
    type: "String",
    rules: [],
    value: "",
    sortable: true,
    filterable: true
  },
  Email: {
    displayName: "Email",
    type: "Email",
    rules: [],
    value: "",
    sortable: true,
    filterable: true
  },
  NotifyInviter: {
    displayName: "Get email when user signs up",
    type: "Bool",
    rules: [],
    value: false,
    sortable: true,
    filterable: true
  },
  InviterId: {
    displayName: "Inviter",
    type: "Relation",
    expanded: "Inviter",
    entity: {
      foreign: "User",
      getDisplayName: entity => `${entity.GivenName} ${entity.FamilyName}`
    },
    guarded: true,
    sortable: true,
    filterable: false
  },
  Status: {
    displayName: "Status",
    type: "Enum",
    options: {
      0: "Undefined",
      1: "Sent",
      2: "Error",
      3: "Accepted",
      4: "EmailDoesNotExist",
      5: "Outdated",
      6: "AcceptedOther"
    },
    guarded: true,
    sortable: true,
    filterable: true
  },
  CreatedAt: {
    displayName: "Created",
    type: "Date",
    format: value => value ? (0, _moment.default)(value).format("DD.MM.YYYY") : null,
    guarded: true,
    sortable: true,
    filterable: true
  },
  UpdatedAt: {
    displayName: "Updated",
    type: "Date",
    format: value => value ? (0, _moment.default)(value).format("DD.MM.YYYY") : null,
    guarded: true,
    sortable: true,
    filterable: true
  },
  UserLicense: {
    displayName: "License",
    type: "Relation",
    expanded: "UserLicense",
    entity: {
      foreign: "License",
      filterString: value => `Name != null and Name.Contains("License")`,
      getDisplayName: entity => `${entity.Name}`,
      displayName: "Name"
    },
    sortable: true,
    filterable: false
  }
};
module.exports = exports.default;